<template>
  <div id="dynastyCir"></div>
</template>

<script>
export default {
  name: "ChartDynastyCir",
  props: ["templeDate"],
  data() {
    return {
      dynasty: {}, //朝代分类
    };
  },
  watch: {
    templeDate: {
      deep: true,
      handler(newVal, oldVal) {
        this.dynasty = newVal;
        this.getDynastyCIR();
      },
    },
  },
  created() {},
  mounted() {},
  methods: {
    getDynastyCIR() {
      var that = this;
      var dynastyCir = this.$echarts.init(
        document.getElementById("dynastyCir")
      );
      var option;
      option = {
        title: {
          text: that.$t("chart.t5"),
          // subtext: "",
        },
        legend: {
          bottom: "5px",
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        // toolbox: {
        //   //echart保存为图片
        //   show: true,
        //   feature: {
        //     mark: {
        //       show: true,
        //     },
        //     // restore: {
        //     //   show: true,
        //     // },
        //     saveAsImage: {
        //       show: true,
        //       pixelRatio: 1,
        //       title: "保存为图片",
        //       type: "png",
        //       lang: ["点击保存"],
        //     },
        //   },
        // },
        series: [
          {
            // 妈祖庙数量
            name: that.$t("chart.t6"),
            type: "pie",
            radius: "75%",
            // avoidLabelOverlap: false,
            itemStyle: {
              // borderRadius: 10,
              shadowBlur: 1,
              // color: "rgb(46, 199, 201)",
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
              normal: {
                color: function (colors) {
                  var colorList = [
                    "rgb(182, 162, 222)",
                    "rgb(255, 185, 128)",
                    "rgb(90, 177, 239)",
                    "rgb(216, 122, 128)",
                    "rgb(145, 205, 119)",
                    "rgb(229, 129, 182)",
                    "rgb(46, 199, 201)",
                  ];
                  return colorList[colors.dataIndex];
                },
              },
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            labelLine: {
              show: true,
            },
            data: [
              { value: that.dynasty.song, name: that.$t("chart.song") },
              { value: that.dynasty.yuan, name: that.$t("chart.yuan") },
              { value: that.dynasty.ming, name: that.$t("chart.ming") },
              { value: that.dynasty.qing, name: that.$t("chart.qing") },
              { value: that.dynasty.minguo, name: that.$t("chart.min") },
              { value: that.dynasty.xiandai, name: that.$t("chart.xiandai") },
              { value: that.dynasty.unknow, name: that.$t("chart.unknow") },
            ],
            animationEasing: "cubicInOut",
            animationDuration: 2600,
          },
        ],
      };

      option && dynastyCir.setOption(option);
      // 响应布局
      window.addEventListener("resize", () => {
        dynastyCir.resize();
      });
    },
  },
  beforeDestroy() {
    // this.chart.dispose()
  },
};
</script>

<style lang="scss" scoped>
</style>
